<template>
  <div class="">
    <div>
      <div class="block">
        <!-- <span class="demonstration"></span> -->
        <!-- <el-row>
        <el-button plain 
          :options="options"
          v-model="selectedOptions">朴素按钮</el-button>
        <el-button plain @click="datasci()">朴素按钮</el-button>
        <el-button plain>朴素按钮</el-button>
        </el-row>
        <br> -->
        <el-cascader
          expand-trigger="hover"
          :options="options"
          v-model="selectedOptions"
          @change="handleChange"
          placeholder='Search <Data Engineer>'
          size="medium"
          filterable>
        </el-cascader>
      </div>
      
      <div v-if="totalPage===0">
        <br>
        <h1>Data Scientist in Taiwan</h1>
        <div class=" in-contain">
          <!-- <div  class="job-list" > -->
            <el-table
            :data="tableData"
            style="width: 100%">
            <el-table-column type="expand">
              <template slot-scope="props">
                <el-form label-position="left" inline class="demo-table-expand">
                  <el-form-item label="公司名稱">
                    <span>{{ props.row.companyName }}</span>
                  </el-form-item>
                  <el-form-item label="公司地址">
                    <span>{{ props.row.companyAddr }}</span>
                  </el-form-item>
                  <el-form-item label="工作職稱">
                    <span>{{ props.row.jobName }}</span>
                  </el-form-item>
                  <el-form-item label="要求經歷">
                    <span>{{ props.row.exp }}</span>
                  </el-form-item>
                  <el-form-item label="要求學歷">
                    <span>{{ props.row.edu }}</span>
                  </el-form-item>
                  <el-form-item label="產業">
                    <span>{{ props.row.industry }}</span>
                  </el-form-item>
                  <el-form-item label="職缺描述">
                    <span>{{ props.row.simpleJD }}</span>
                  </el-form-item>
                </el-form>
              </template>
                </el-table-column>
                <el-table-column
                  label="公司名稱"
                  prop="companyName"
                  width=300>
                </el-table-column>
                <el-table-column
                  label="工作職稱"
                  prop="jobName"
                  width=400>
                </el-table-column>
                <el-table-column
                  label="公司地址"
                  prop="companyAddr">
                </el-table-column>
                <el-table-column
                  label="薪資待遇"
                  prop="salary">
                </el-table-column>
              </el-table>
          <!-- </div> -->
        </div>
      </div>

      <!-- <div v-show="totalPage!==0" class="search-bar">
        <p>Filter <input type="search" v-text="text" v-model="filter_name"></p>
      </div> -->

      <div v-loading="loading" :data="filteredRows" class="jobcontainer flexcol">
        <div class=" in-contain">
          <div  class="job-list" >
            <!-- Pagination -->
            <div v-show="totalPage!==0" class="pagination" >
              <div class="page-margin">
                <span class="li-pointer" :class="{'disabled':(currPage ===1)}"
                @click.prevent="setPage(currPage-1)"><a href="#">
                  <svg class="svg-icon" viewBox="0 0 20 20">
                    <path d="M11.739,13.962c-0.087,0.086-0.199,0.131-0.312,0.131c-0.112,0-0.226-0.045-0.312-0.131l-3.738-3.736c-0.173-0.173-0.173-0.454,0-0.626l3.559-3.562c0.173-0.175,0.454-0.173,0.626,0c0.173,0.172,0.173,0.451,0,0.624l-3.248,3.25l3.425,3.426C11.911,13.511,11.911,13.789,11.739,13.962 M18.406,10c0,4.644-3.763,8.406-8.406,8.406S1.594,14.644,1.594,10S5.356,1.594,10,1.594S18.406,5.356,18.406,10 M17.521,10c0-4.148-3.373-7.521-7.521-7.521c-4.148,0-7.521,3.374-7.521,7.521c0,4.148,3.374,7.521,7.521,7.521C14.147,17.521,17.521,14.148,17.521,10"></path>
                  </svg>
                </a></span>
              <span>Page {{currPage}} / {{totalPage}}</span>
                <span class="li-pointer" v-bind:class="{'disabled':(currPage === totalPage)}"
                @click.prevent="setPage(currPage+1)"><a href="#">
                  <svg class="svg-icon" viewBox="0 0 20 20">
                    <path d="M12.522,10.4l-3.559,3.562c-0.172,0.173-0.451,0.176-0.625,0c-0.173-0.173-0.173-0.451,0-0.624l3.248-3.25L8.161,6.662c-0.173-0.173-0.173-0.452,0-0.624c0.172-0.175,0.451-0.175,0.624,0l3.738,3.736C12.695,9.947,12.695,10.228,12.522,10.4 M18.406,10c0,4.644-3.764,8.406-8.406,8.406c-4.644,0-8.406-3.763-8.406-8.406S5.356,1.594,10,1.594C14.643,1.594,18.406,5.356,18.406,10M17.521,10c0-4.148-3.374-7.521-7.521-7.521c-4.148,0-7.521,3.374-7.521,7.521c0,4.147,3.374,7.521,7.521,7.521C14.147,17.521,17.521,14.147,17.521,10"></path>
                  </svg>
                </a></span>
              </div>
            </div>
            <!-- Pagination -->
            <el-row :gutter="24">
                <div class="wrap-card" v-for="(job,index) in filteredRows.slice(pageStart, pageStart + countOfPage).reverse()" :key="index">
                  <el-col :xl="8" :lg="8" :md="8" :sm="12" :xs="24">
                  <el-card >
                    <a target="_blank" :href="job.jobLink" style="color:black">
                    <h1>{{job.jobName}}</h1>
                    </a>
                    <!-- [id: {{ job.id }} - 
                    name: {{ job.name }}] -->
                    <h4>{{job.companyName}}</h4>
                    <!-- <el-collapse v-model="activeName" accordion> -->
                      <!-- <el-collapse-item v-show="job.simpleJD!=null" title="Job Description" name="1">
                        <p v-show="job.simpleJD!=null" v-html="job.simpleJD"></p>
                      </el-collapse-item> -->
                      <!-- <el-collapse-item  v-show="job.requirement!=null" title="requirement" name="2">
                        <p v-show="job.requirement!=null" v-html="job.requirement"></p>
                      </el-collapse-item> -->
                      <!-- <el-collapse-item v-show="job.other!=null" title="We hope you ..." name="3">
                        <p v-show="job.other!=null" v-html="job.other"></p>
                      </el-collapse-item>
                      <el-collapse-item v-show="job.asked!=null" title="And one more thing ..." name="ˋ">
                        <p v-show="job.asked!=null" v-html="job.asked"></p>
                      </el-collapse-item> -->
                    <!-- </el-collapse> -->
                    <h5>Job Description</h5>
                      <p>{{job.simpleJD}}</p>
                    <div>{{job.salary}}</div>
                    <br>
                    <el-tag type="warning"><div>{{job.date}}</div></el-tag>
                    <el-tag type="info"><div>{{job.companyAddr}}</div></el-tag>
                    <el-tag type="info"><div>{{job.industry}}</div></el-tag>
                    <br>
                    <el-tag type="info"><div>經驗{{job.exp}}</div></el-tag>
                    <el-tag type="info"><div>學歷{{job.edu}}</div></el-tag>
                    <br>
                    <br>
                    <el-button type="warning" >
                    <a target="_blank" :href="job.jobLink">前往{{job.source}}應徵此工作</a>
                    </el-button>
                    <br>
                    <div class="divblock"></div>
                </el-card >
                </el-col>
                </div>
            </el-row>
            <!-- <div class="jobdiv" v-for="(job,index) in filteredRows.slice(pageStart, pageStart + countOfPage).reverse()" :key="index">
              <router-link class="jobtitle" target="_self" :to="{
                name: 'Joblist-details',
                params: { name: job.jobName, 
                          id: job.id, 
                          com: job.companyName,
                          joblink: job.jobLink,
                          comLink: job.companyLink,
                          addr: job.companyAddr,
                          ind: job.industry,
                          jd: job.simpleJD,
                          exp: job.exp,
                          edu: job.edu,
                          sal: job.salary,
                          src: job.source,
                          date: job.date}
              }">
                <div class="jobname">{{job.jobName}}</div>
                </router-link>
              </div>
            </div>
            <div class="detail-list">
              <router-view></router-view>
            </div> -->
             <!-- Pagination -->
            <div v-show="totalPage!==0" class="pagination" >
              <div class="page-margin bottom-pagination">
                <span class="li-pointer" :class="{'disabled':(currPage ===1)}"
                @click.prevent="setPage(currPage-1)"><a href="#">
                  <svg class="svg-icon" viewBox="0 0 20 20">
                    <path d="M11.739,13.962c-0.087,0.086-0.199,0.131-0.312,0.131c-0.112,0-0.226-0.045-0.312-0.131l-3.738-3.736c-0.173-0.173-0.173-0.454,0-0.626l3.559-3.562c0.173-0.175,0.454-0.173,0.626,0c0.173,0.172,0.173,0.451,0,0.624l-3.248,3.25l3.425,3.426C11.911,13.511,11.911,13.789,11.739,13.962 M18.406,10c0,4.644-3.763,8.406-8.406,8.406S1.594,14.644,1.594,10S5.356,1.594,10,1.594S18.406,5.356,18.406,10 M17.521,10c0-4.148-3.373-7.521-7.521-7.521c-4.148,0-7.521,3.374-7.521,7.521c0,4.148,3.374,7.521,7.521,7.521C14.147,17.521,17.521,14.148,17.521,10"></path>
                  </svg>
                </a></span>
              <span>Page {{currPage}} / {{totalPage}}</span>
                <span class="li-pointer" v-bind:class="{'disabled':(currPage === totalPage)}"
                @click.prevent="setPage(currPage+1)"><a href="#">
                  <svg class="svg-icon" viewBox="0 0 20 20">
                    <path d="M12.522,10.4l-3.559,3.562c-0.172,0.173-0.451,0.176-0.625,0c-0.173-0.173-0.173-0.451,0-0.624l3.248-3.25L8.161,6.662c-0.173-0.173-0.173-0.452,0-0.624c0.172-0.175,0.451-0.175,0.624,0l3.738,3.736C12.695,9.947,12.695,10.228,12.522,10.4 M18.406,10c0,4.644-3.764,8.406-8.406,8.406c-4.644,0-8.406-3.763-8.406-8.406S5.356,1.594,10,1.594C14.643,1.594,18.406,5.356,18.406,10M17.521,10c0-4.148-3.374-7.521-7.521-7.521c-4.148,0-7.521,3.374-7.521,7.521c0,4.147,3.374,7.521,7.521,7.521C14.147,17.521,17.521,14.147,17.521,10"></path>
                  </svg>
                </a></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
var tableData = [{
companyName: "DT42_灼灼科技股份有限公司",
companyLink: "https://www.104.com.tw/jobbank/custjob/index.php?r=cust&j=44524a733c3e466f383a426b40463e219313131744a3e3e7109j52&jobsource=2018indexpoc",
jobName: "[108年研發替代役] Junior Data Scientist",
jobLink: "https://www.104.com.tw/job/?jobno=6jk9g&jobsource=2018indexpoc",
companyAddr: "台北市信義區",
simpleJD: "We are looking for a new partner who is eager to create value out of data. We expect this person will love to fetch",
industry: "電腦軟體服務業",
salary: "待遇面議",
exp: "經歷不拘",
edu: "碩士",
date: "4/01",
source: "104",
id: 673
},
{
companyName: "LINE Taiwan_台灣連線股份有限公司",
companyLink: "https://www.104.com.tw/jobbank/custjob/index.php?r=cust&j=553f4770393b436c35373f683d433b1e12e2e2e7146713f2634j53&jobsource=2018indexpoc",
jobName: "(LTEG) Data Scientist - Machine Learning (Senior)",
jobLink: "https://www.104.com.tw/job/?jobno=6gu8p&jobsource=2018indexpoc",
companyAddr: "台北市內湖區",
simpleJD: " visualization, machine learning, optimization and big data",
industry: "電腦系統整合服務業",
salary: "待遇面議",
exp: "5年以上",
edu: "大學",
date: "4/01",
source: "104",
id: 679
},
{
companyName: "台達電子工業股份有限公司 _DELTA ELECTRONICS INC.",
companyLink: "https://www.104.com.tw/jobbank/custjob/index.php?r=cust&j=3860422938463f6740683a1d1d1d1d5f2443a363189j56&jobsource=2018indexpoc",
jobName: "Senior Machine Learning Data Scientist_台達研究院(台北)",
jobLink: "https://www.104.com.tw/job/?jobno=5re6t&jobsource=2018indexpoc",
companyAddr: "台北市內湖區",
simpleJD: "「台達研究院」成立於2013年，除致力於大數據分析及物聯網應用與解決方案的開發與整合，加速企業轉型成功，也積極與產官學研生態體系協作，以開放創新模式，創造多贏生態圈。 本職主要工作內容: 1.	面對客戶討論問題，提出基於資料分析的解決之道 2.	以統計與機器學習手法分析資料，尋求解決問題的方案 3.	設計資料分析服務的方法 4.	與團隊合作，進行較大規模的資料分析工作 5. 協助資料分析服務業務之推動 ",
industry: "其他電子零組件相關業",
salary: "待遇面議",
exp: "3年以上",
edu: "碩士",
date: "4/01",
source: "104",
id: 713
},
{
companyName: "104人力銀行_一零四資訊科技股份有限公司",
companyLink: "https://www.104.com.tw/jobbank/custjob/index.php?r=cust&j=623a436e5a46402140323c1d1d1d1d5f2443a363189j50&jobsource=2018indexpoc",
jobName: "Data Scientist",
jobLink: "https://www.104.com.tw/job/?jobno=3wst4&jobsource=2018indexpoc",
companyAddr: "新北市新店區",
simpleJD: "As a Data Scientist at 104, you will develop innovative new features and products that help user get a better job and help",
industry: "網際網路相關業",
salary: "待遇面議",
exp: "3年以上",
edu: "碩士",
date: "4/01",
source: "104",
id: 721
},
{
companyName: "台達電子工業股份有限公司 _DELTA ELECTRONICS INC.",
companyLink: "https://www.104.com.tw/jobbank/custjob/index.php?r=cust&j=3860422938463f6740683a1d1d1d1d5f2443a363189j56&jobsource=2018indexpoc",
jobName: "[AICoE] AI Data Scientist 人工智慧資料科學家_台達研究院(台北)",
jobLink: "https://www.104.com.tw/job/?jobno=6h22n&jobsource=2018indexpoc",
companyAddr: "台北市內湖區",
simpleJD: "大數據分析已成為企業競爭力的重要關鍵之一，其中人工智慧 (Artificial Intelligence)被視為是翻轉產業的革命型技術。台達電子為了加速產業界導入AI應用，創造智慧化的加值服務，整合AI相關技術與培訓資源，因而成立AI創新中心(AI Center of Excellence)。 因應瞬息萬變的商業環境，共享與協作才能快速創新，這是AI創新中心在資源及服務上的定位，台達將透過此中心的資源來培訓人才並與台達內部各單位合作，落實AI技術於各式服務。 加入本中心, 你/妳將會有機會參與以下題目的數據分析工作: 1.	Video & Image Processing: 缺陷偵測、物件偵測 2.	Bio-image Analytics, Bio-fluorescence Image: 生醫影像分析、生醫文字探勘 3.	Operations Research: 生產排程最佳化、運輸派送最佳化、產能最佳化 4.	Natural Language Processing:	工業領域斷詞、詞性標注、命名實體識別; 工業領域知識圖譜建構; 閱讀理解為基礎的問答系統建構 5.	Time Series Analysis:	產品品質診斷、機台預測維護(predictive maintenance) 主要工作內容： 1.	以統計、機器學習與深度學習分析內外部客戶資料，提供合適的解決方案 2.	研究與開發數據分析及最佳化技術之演算法及應用 3.	設計、協助及管理數據分析服務及人工智慧專案等業務之推動 4. 參與智慧製造、智慧生活、智慧醫療、智慧企業等產業轉型專案，並協助設計相關流程 ",
industry: "其他電子零組件相關業",
salary: "待遇面議",
exp: "經歷不拘",
edu: "碩士",
date: "4/01",
source: "104",
id: 1191
},
{
companyName: "露天市集國際資訊股份有限公司",
companyLink: "https://www.104.com.tw/jobbank/custjob/index.php?r=cust&j=5a3a432634463e6956583a1d1d1d1d5f2443a363189j97&jobsource=2018indexpoc",
jobName: "露天市集-Data Scientist(DA)",
jobLink: "https://www.104.com.tw/job/?jobno=5ubdy&jobsource=2018indexpoc",
companyAddr: "台北市大安區",
simpleJD: "1. 收集、組織和分析業務相關的數據和信息，從而建構完善的數據模型。 2. 運用機器學習和分析技術為消費者行為建立預測模型。 3. 設計統計實驗方式與技術團隊合作收集數據。 4. 研究與評估開創性機器學習與統計模型設計。 ",
industry: "網際網路相關業",
salary: "待遇面議",
exp: "3年以上",
edu: "大學",
date: "4/01",
source: "104",
id: 1407
},
{
companyName: "Linker Networks Inc._美商寶蘊凌科網路科技有限公司台灣分公司",
companyLink: "https://www.104.com.tw/jobbank/custjob/index.php?r=cust&j=5d39416a33353d662f313962373d35186282828254135456795j00&jobsource=2018indexpoc",
jobName: "Data Scientist (RAISE Program for PhD only)",
jobLink: "https://www.104.com.tw/job/?jobno=6fm9v&jobsource=2018indexpoc",
companyAddr: "台北市大安區",
simpleJD: "We're building the container-based platform for the 5G and AI industry. We have a solid R&D & Data Scientist team and now",
industry: "電腦軟體服務業",
salary: "待遇面議",
exp: "3年以上",
edu: "博士",
date: "4/01",
source: "104",
id: 1409
},
{
companyName: "LINE Taiwan_台灣連線股份有限公司",
companyLink: "https://www.104.com.tw/jobbank/custjob/index.php?r=cust&j=553f4770393b436c35373f683d433b1e12e2e2e7146713f2634j53&jobsource=2018indexpoc",
jobName: "(LTEG) Data Analyst",
jobLink: "https://www.104.com.tw/job/?jobno=6gu7r&jobsource=2018indexpoc",
companyAddr: "台北市內湖區",
simpleJD: "[About this Job] We are looking for a savvy Data Scientist with technical backgrounds in data analysis. If you want to",
industry: "電腦系統整合服務業",
salary: "待遇面議",
exp: "3年以上",
edu: "大學",
date: "4/01",
source: "104",
id: 1411
},
{
companyName: "LINE Taiwan_台灣連線股份有限公司",
companyLink: "https://www.104.com.tw/jobbank/custjob/index.php?r=cust&j=553f4770393b436c35373f683d433b1e12e2e2e7146713f2634j53&jobsource=2018indexpoc",
jobName: "(LTEG) Data Scientist - Machine Learning (Junior)",
jobLink: "https://www.104.com.tw/job/?jobno=6gu8v&jobsource=2018indexpoc",
companyAddr: "台北市內湖區",
simpleJD: "[About this Job] We are looking for a savvy Data Scientist with technical backgrounds machine learning techniques and",
industry: "電腦系統整合服務業",
salary: "待遇面議",
exp: "2年以上",
edu: "大學",
date: "4/01",
source: "104",
id: 1628
},
{
companyName: "台達電子工業股份有限公司 _DELTA ELECTRONICS INC.",
companyLink: "https://www.104.com.tw/jobbank/custjob/index.php?r=cust&j=3860422938463f6740683a1d1d1d1d5f2443a363189j56&jobsource=2018indexpoc",
jobName: "Operation Research Data Scientist_台達研究院(台北)",
jobLink: "https://www.104.com.tw/job/?jobno=4xrix&jobsource=2018indexpoc",
companyAddr: "台北市內湖區",
simpleJD: "「台達研究院」成立於2013年，除致力於大數據分析及物聯網應用與解決方案的開發與整合，加速企業轉型成功，也積極與產官學研生態體系協作，以開放創新模式，創造多贏生態圈。 本職工作內容包含: 1.	以統計與機器學習手法分析資料，尋求解決問題的方案。 2.	應用作業研究(Operation research)、機器學習和人工智慧等技術解決分析與優化生產製造相關專案。 3.	協助與負責生產排程優化、運輸派送問題優化、設備預防性維護(predictive maintenance)機制優化，或產能瓶頸優化等改善專案。 4.	與團隊合作，進行較大規模的資料分析工作。 5.	研究與開發分析優化技術之演算法。 6.	跨功能與跨公司單位之溝通合作與專案管理。 ",
industry: "其他電子零組件相關業",
salary: "待遇面議",
exp: "1年以上",
edu: "碩士",
date: "4/01",
source: "104",
id: 1638
}]
var options = [{
          value: 'Data',
          label: 'Data',
          children: [{
            value: 'Engineer',
            label: 'Engineer',
            children: [{
                value: 'dataengineer',
                label: 'Data Engineer'
            },{
                value: 'hadoop',
                label: 'Hadoop'
            }]
          }, {
            value: 'analyst',
            label: 'Analyst',
            children: [
                {
                    value: 'BI',
                    label: 'Business Intelligence'
                },
                {
                    value: '資料分析',
                    label: 'Data Analyst'
                },
                {
                    value: 'data+mining',
                    label: 'Data Mining'
                },
                {
                    value: 'data+scientist',
                    label: 'Data Scientist'
                }
            ]
          }, {
            value: 'AI',
            label: 'AI',
            children: [
                {
                    value: 'machinelearning',
                    label: 'Machine Learning'
                },
                {
                    value: 'computervision',
                    label: 'Computer Vision'
                },
                {
                    value: 'nlp',
                    label: 'NLP'
                }
            ]
          }, {
            value: 'dba',
            label: 'DBA'
          }, {
            value: 'algorithm',
            label: 'Algorithm'
          }]
        },
        {
          value: 'lang',
          label: 'Language',
          children: [{
            value: 'python',
            label: 'Python'
          }, {
            value: 'java',
            label: 'Java'
          }, {
            value: 'spark',
            label: 'Spark'
          }, {
            value: 'golang',
            label: 'Golang'
          }, {
            value: 'javascript',
            label: 'Javascript'
          }, {
            value: 'php',
            label: 'PHP'
          }, {
            value: 'ror',
            label: 'Ruby on Rails'
          }]
        },
        {
            value: 'web',
            label: 'Web',
            children: [{
                value: 'frontend',
                label: 'Front-End'
            },{
                value: 'backend',
                label: 'Backend'
            },{
                value: 'fullstack',
                label: 'Full-Stack'
            },{
                value: 'uxui',
                label: 'UX/UI'
            }]
        },
        {
            value: 'other',
            label: 'Other',
            children: [{
                value: 'intern',
                label: 'Intern'
            },{
                value: 'devops',
                label: 'DevOps'
            },{
                value: 'architect',
                label: 'Architect'
            },{
                value: 'qa',
                label: 'QA'
            },{
                value: 'manager',
                label: 'Tech Manager'
            },{
                value: 'productmanager',
                label: 'Product Manager'
            },{
                value: 'projectmanager',
                label: 'Project Manager'
            }]
        }]
export default {
  data () {
    return {
      tableData:tableData,
      options:options,
      selectedOptions: [],
      jobs: [],
      jobcategory: '',
      countOfPage:3,
      currPage: 0,
      filter_name: '',
      selected: null,
      tabPosition: 'top',
      activeName: ''
    }
  },
  components: {	// 挂载组件
    // pro,
    // VPaginator: VuePaginator
  },
  created() {
    // window.addEventListener('load', () => {
    //   this.fetchData();// run after everything is in-place
    // })
    this.datasci();// run after everything is in-place
  },
  watch: {
    // 如果路由有变化，会再次执行该方法
    '$route': 'datasci'
  },
  methods: {
    datasci() {
      var self = this;
          var key = 'data scientis|Data Scientist|資料科學';
          $.get("https://wetogetherjobdb.herokuapp.com/job?q=data+scientist&_limit=20", function(data){
          self.jobs = data.filter((item) => item.jobName.match(key));
          self.currPage = 1;
          });
      },
    handleChange(value) {
      // 28個jobcategory
      var self = this;
      self.jobcategory = value[value.length - 1]
      if (self.jobcategory === "dataengineer"){
        // 1
        var key = 'Data Engineer|data engineer|資料工程|資料處理|ETL|etl';
        var self = this;
        fetch("https://wetogetherjobdb.herokuapp.com/job?q=data+engineer")
        .then(function(response) {
          return response.json();
        })
        .then(function(myJson) {
          self.jobs = myJson.filter((item)=>item.jobName.match(key))
          self.currPage = 1;
        });
      } else if (self.jobcategory === "hadoop"){
        // 2 
        var key = 'Hadoop|hadoop|Hive|hive|cloudera|Hbase|hbase|YARN|yarn';
        var self = this;
        fetch("https://wetogetherjobdb.herokuapp.com/job?q=hadoop")
        .then(function(response) {
          return response.json();
        })
        .then(function(myJson) {
          self.jobs = myJson.filter((item)=>item.simpleJD.match(key))
          self.currPage = 1;
        });
      } else if (self.jobcategory === "BI"){
        // 3 BI
        var key = '商業分析|商業智慧|Bussiness|bussiness|視覺化|tableau|Tableau';
        var self = this;
        fetch("https://wetogetherjobdb.herokuapp.com/job?q=BI")
        .then(function(response) {
          return response.json();
        })
        .then(function(myJson) {
          self.jobs = myJson.filter((item)=>item.simpleJD.match(key))
          self.currPage = 1;
        });
      } else if (self.jobcategory === "資料分析"){
        // 4 analyst
        var key = '資料分析|data analyst|Data Analyst|分析|視覺化';
        fetch("https://wetogetherjobdb.herokuapp.com/job?q=data+analyst")
        .then(function(response) {
          return response.json();
        })
        .then(function(myJson) {
          self.jobs = myJson.filter((item)=>item.simpleJD.match(key))
          self.currPage = 1;
        });
      } else if (self.jobcategory === "data+mining"){
        // 4 data mining
        var key = 'data mining|資料挖掘|資料挖礦|Data Mining|資料探勘';
        fetch("https://wetogetherjobdb.herokuapp.com/job?q=data+mining")
        .then(function(response) {
          return response.json();
        })
        .then(function(myJson) {
          self.jobs = myJson.filter((item)=>item.simpleJD.match(key))
          self.currPage = 1;
        });
      } else if (self.jobcategory === "data+scientist"){
        // 5 data scientist
        var key = 'data scientist|Data Scientist|資料科學'
        fetch("https://wetogetherjobdb.herokuapp.com/job?q=資料")
        .then(function(response) {
          return response.json();
        })
        .then(function(myJson) {
          self.jobs = myJson.filter((item)=>item.simpleJD.match(key))
          self.currPage = 1;
        });
      } else if (self.jobcategory === "machinelearning"){
        // 6 machinelearning
        var key = '人工智慧|Machine Learning|Deep Learning|machine learning|deep learning|機器學習|深度學習|人工智能|ml|ML'
        fetch("https://wetogetherjobdb.herokuapp.com/job?q=machine+learning")
        .then(function(response) {
          return response.json();
        })
        .then(function(myJson) {
          self.jobs = myJson.filter((item)=>item.simpleJD.match(key))
          self.currPage = 1;
        });
      } else if (self.jobcategory === "computervision"){
        // 7 computervision
        var key = '電腦視覺|computer vision|CV'
        fetch("https://wetogetherjobdb.herokuapp.com/job?q=computer+vision")
        .then(function(response) {
          return response.json();
        })
        .then(function(myJson) {
          self.jobs = myJson.filter((item)=>item.simpleJD.match(key))
          self.currPage = 1;
        });
      } else if (self.jobcategory === "nlp"){
        // 8 nlp
        var key = '自然語言|nlp|NLP|自然語意'
        fetch("https://wetogetherjobdb.herokuapp.com/job?q=nlp")
        .then(function(response) {
          return response.json();
        })
        .then(function(myJson) {
          self.jobs = myJson.filter((item)=>item.simpleJD.match(key))
          self.currPage = 1;
        });
      } else if (self.jobcategory === "dba"){
        // 9 DBA
        var key = '資料倉儲|資料庫'
        fetch("https://wetogetherjobdb.herokuapp.com/job?q=DBA")
        .then(function(response) {
          return response.json();
        })
        .then(function(myJson) {
          self.jobs = myJson.filter((item)=>item.simpleJD.match(key))
          self.currPage = 1;
        });
      } else if (self.jobcategory === "algorithm"){
        // 10 algorithm
        var key = 'algorithm|演算法'
        fetch("https://wetogetherjobdb.herokuapp.com/job?q=algorithm")
        .then(function(response) {
          return response.json();
        })
        .then(function(myJson) {
          self.jobs = myJson.filter((item)=>item.simpleJD.match(key))
          self.currPage = 1;
        }); 
      } else if (self.jobcategory == 'python'){
        var key = 'python|Python';
        fetch("https://wetogetherjobdb.herokuapp.com/job?q=python")
        .then(function(response) {
          return response.json();
        })
        .then(function(myJson) {
          self.jobs = myJson.filter((item)=>item.jobName.match(key))
          self.currPage = 1;
        });
      } else if (self.jobcategory === 'java'){
        var key = 'JAVA|java|Java';
        fetch("https://wetogetherjobdb.herokuapp.com/job?q=java")
        .then(function(response) {
          return response.json();
        })
        .then(function(myJson) {
          self.jobs = myJson.filter((item)=>item.jobName.match(key))
          self.currPage = 1;
        });
      } else if (self.jobcategory === "spark"){
        var key = 'spark|Spark';
      fetch("https://wetogetherjobdb.herokuapp.com/job?q=spark")
      .then(function(response) {
        return response.json();
      })
      .then(function(myJson) {
        self.jobs = myJson.filter((item)=>item.jobName.match(key))
        self.currPage = 1;
      });
      } else if (self.jobcategory === "golang"){
        var key = 'golang|Golang|GO|go';
      fetch("https://wetogetherjobdb.herokuapp.com/job?q=golang")
      .then(function(response) {
        return response.json();
      })
      .then(function(myJson) {
        self.jobs = myJson.filter((item)=>item.jobName.match(key))
        self.currPage = 1;
      });
      } else if (self.jobcategory === "javascript"){
        var key = 'javascript|Javascript|js|JS';
      fetch("https://wetogetherjobdb.herokuapp.com/job?q=javascript")
      .then(function(response) {
        return response.json();
      })
      .then(function(myJson) {
        self.jobs = myJson.filter((item)=>item.jobName.match(key))
        self.currPage = 1;
      });
      } else if (self.jobcategory === "php"){
        var key = 'php|PHP';
      fetch("https://wetogetherjobdb.herokuapp.com/job?q=php")
      .then(function(response) {
        return response.json();
      })
      .then(function(myJson) {
        self.jobs = myJson.filter((item)=>item.jobName.match(key))
        self.currPage = 1;
      });
      }else if (self.jobcategory === "ror"){
        var key = 'ruby|Ruby';
      fetch("https://wetogetherjobdb.herokuapp.com/job?q=ruby+on+rails")
      .then(function(response) {
        return response.json();
      })
      .then(function(myJson) {
        self.jobs = myJson.filter((item)=>item.jobName.match(key))
        self.currPage = 1;
      });
      } else if (self.jobcategory === 'frontend'){
      var key = 'frontend|Front-End|front-end|前端|網頁設計|Frontend';
      fetch("https://wetogetherjobdb.herokuapp.com/job?q=web")
      .then(function(response) {
        return response.json();
      })
      .then(function(myJson) {
        self.jobs = myJson.filter((item)=>item.jobName.match(key))
        self.currPage = 1;
      });
      } else if (self.jobcategory === "backend"){
        var key = 'backend|Back-End|back-end|後端|Backend';
        fetch("https://wetogetherjobdb.herokuapp.com/job?q=backend")
        .then(function(response) {
          return response.json();
        })
        .then(function(myJson) {
          self.jobs = myJson.filter((item)=>item.jobName.match(key))
          self.currPage = 1;
        });
      } else if (self.jobcategory === "fullstack"){
        var key = 'fullstack|Fullstack|全端|Full Stack|web';
      fetch("https://wetogetherjobdb.herokuapp.com/job?q=web")
      .then(function(response) {
        return response.json();
      })
      .then(function(myJson) {
        self.jobs = myJson.filter((item)=>item.jobName.match(key))
        self.currPage = 1;
      });
      } else if (self.jobcategory === "uxui"){
        var key = 'UIUX|ux design|ui|UX Design|UI|使用者體驗|user experience';
      fetch("https://wetogetherjobdb.herokuapp.com/job?q=ux")
      .then(function(response) {
        return response.json();
      })
      .then(function(myJson) {
        self.jobs = myJson.filter((item)=>item.jobName.match(key))
        self.currPage = 1;
      });
      } else if (self.jobcategory === "manager"){
        var key = 'manager|Manager|經理|主管|lead|leader';
      fetch("https://wetogetherjobdb.herokuapp.com/job?q=manager")
      .then(function(response) {
        return response.json();
      })
      .then(function(myJson) {
        self.jobs = myJson.filter((item)=>item.jobName.match(key))
        self.currPage = 1;
      });
      } else if (self.jobcategory === "intern"){
      var key = '實習';
      fetch("https://wetogetherjobdb.herokuapp.com/job?q=intern")
      .then(function(response) {
        return response.json();
      })
      .then(function(myJson) {
        self.jobs = myJson.filter((item)=>item.jobName.match(key))
        self.currPage = 1;
      });
      } else if (self.jobcategory === "devops"){
        var key = 'devops|DevOps';
      fetch("https://wetogetherjobdb.herokuapp.com/job?q=devops")
      .then(function(response) {
        return response.json();
      })
      .then(function(myJson) {
        self.jobs = myJson.filter((item)=>item.jobName.match(key))
        self.currPage = 1;
      });
      } else if (self.jobcategory === "architect"){
        var key = 'architect|Architect|架構師';
      fetch("https://wetogetherjobdb.herokuapp.com/job?q=architect")
      .then(function(response) {
        return response.json();
      })
      .then(function(myJson) {
        self.jobs = myJson.filter((item)=>item.jobName.match(key))
        self.currPage = 1;
      });
      } else if (self.jobcategory === "qa"){
        var key = 'QA|qa|測試|test';
      fetch("https://wetogetherjobdb.herokuapp.com/job?q=測試")
      .then(function(response) {
        return response.json();
      })
      .then(function(myJson) {
        self.jobs = myJson.filter((item)=>item.jobName.match(key))
        self.currPage = 1;
      });
      } else if (self.jobcategory === "productmanager"){
var key = 'product manager|Product Manager|pm|產品';
      fetch("https://wetogetherjobdb.herokuapp.com/job?q=product+manager")
      .then(function(response) {
        return response.json();
      })
      .then(function(myJson) {
        self.jobs = myJson.filter((item)=>item.jobName.match(key))
        self.currPage = 1;
      });
      } else if (self.jobcategory === "projectmanager"){
        var key = 'project manager|Project Manager|pm|專案';
      fetch("https://wetogetherjobdb.herokuapp.com/job?q=project+manager")
      .then(function(response) {
        return response.json();
      })
      .then(function(myJson) {
        self.jobs = myJson.filter((item)=>item.jobName.match(key))
        self.currPage = 1;
      });
      } else {
        console.log(value[value.length - 1])
      }
    },
    open() {
      this.$alert('这是一段内容', '标题名称', {
        confirmButtonText: '确定',
        callback: action => {
          this.$message({
            type: 'info',
            message: `action: ${ action }`
          });
        }
      });
    },
    setPage: function(idx){
      if (idx <= 0 || idx > this.totalPage) {
        return;
      } else {
        this.currPage = idx;
      }
    }
  },
  computed: {
    filteredRows: function(){
      var filter_name = this.filter_name.toLowerCase();
      return (this.filter_name.trim()!=='')?
        this.jobs.filter(function(d){return d.simpleJD.toLowerCase().indexOf(filter_name) > -1;}):
        this.jobs;
    },
    pageStart: function(){
      return (this.currPage - 1)* this.countOfPage;
    },
    totalPage: function(){
      return Math.ceil(this.filteredRows.length / this.countOfPage);
    },
    id(){
      return category[this.$route.params.id];
    }
  },
}


</script>

<style scoped>
.demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90;
    color: #99a9bf;
    font-weight: 800;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 100%;
  }
.bottom-pagination{
      margin-bottom: 2em !important;
    }

.jobcontainer{
  margin:0;
  padding: 0;
}
.jobname{
  margin: 0.2em 0;
  padding: 0.2em;
  color: black;
}
.jobname:hover{
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08)
}
 body {
  display: inline-block;
  margin: 0;
  }
  a{
    color: black;
    text-decoration: none;
    text-decoration-line: none;
  }
  .in-contain{
    margin-left: 5%;
    margin-right: 5%;
  }
  .p-sm{
  font-size: 1.5em !important;
  text-align: center;
  margin-bottom: 0.3em;
  margin-top: 0;
  color: rgba(0, 0, 0, 0.664);
}

  .form-frame{
    /* border: 1px solid rgba(0, 0, 0, 0.219); */
    padding: 2px;
    box-shadow: 1px 1px 1px 1px rgb(0, 0, 0,0.6),
  }

  .radius{
    border-radius: 15px;
  }

  .c-btn {
  padding: .25em;
  display: inline-block;
  text-align: center;
  background-color: rgb(252, 190, 17);
  /* color: #fff; */
  margin: 3px;
  /* padding: 5px; */
  font-weight: 450;
  font-size: 1em;
}
.c-btn:hover,
.c-btn:focus {
  cursor: pointer;
  background-color:  rgb(252, 190, 17,0.8);
  opacity: 0.8;
  color: black !important;
  /* font-weight: 650 !important; */
}
.link-btn {
  color: black !important;
  border-radius: 0.5em;
}

.el-button-wrapper{
  display: flex;
  justify-content: center;
  
}

.search-bar{
  padding: 1em;
  text-align: center;
  margin-top: -5em;
}
input{
  padding: 1em;
  margin-left: 1em;
}
.pagination{
  text-align: center;
  margin-top: 1.5em;
  margin-bottom: 1.5em;
}
li{
  padding: .25em .5em;
  /* border: solid 1px red; */
  border-radius: 4px;
  display: inline-block;
  text-align: center;
  font-size: 1em !important;
  border-bottom: none;
}

.li-pointer{
  cursor: pointer;
  margin-top: -0.3em;
}
.list-group{
margin: 0.2em;
padding: 0.2em;
}
router-link{
text-decoration: none !important;
}
.list-group:hover{
  box-shadow: 3px 3px 5px 5px rgba(0, 0, 0, 0.03);
}
.list-date{
  margin-left: 0.7em;
  margin-bottom: -0.3em;
  margin-top: 0.1em;
}
/* -----
SVG Icons - svgicons.sparkk.fr
----- */

.svg-icon {
  width: 1em;
  height: 1em;
  margin-bottom: -0.15em;
}

.svg-icon path,
.svg-icon polygon,
.svg-icon rect {
  fill: rgb(140, 140, 140);
}

.svg-icon circle {
  stroke: black;
  stroke-width: 1;
}

el-button{
  overflow:inherit;
  max-width: 12px;
}
.job-list{
  display: inline-block;
  overflow: scroll;
}


@media only screen and (max-width: 500px) {
  /* .flexcol{
    display: inline-flex;
    flex-direction: column !important;
  }
  .job-list{
  /* display: inline-flex; */
  /* flex-direction: column; */
  /* width: 100%; */
  /* margin: 0.2em; */
  /* height: auto; */
  /* font-size: 1em; */

/* }  */
.detail-list{
  /* display: inline-block; */
  /* width: 20em; */
  height: auto;
  margin-top: 3em;
  margin-bottom: 5em;
}
.jobtitle{
  margin-top: 1em !important;
}
  .list-group{
    text-align: center;
    float:left;
    width: 15%;
    /* text-decoration: none; */
    /* overflow:scroll; */
  }
  .page-margin{
    margin-bottom: 1em;
    margin-top: 1em;
  }

}

@media only screen and (min-width: 501px) {
  /* .jobdiv{
    margin-top: 2em;
  }
  .in-contain{
    display: flex;
    flex-direction: row !important;
  }
  .job-list{
  display: inline-block;
  width: 50%;
  margin: 0.2em;
  height: auto;
  font-size: 1em;
  overflow: visible;
} */
.detail-list{
  display: inline-block;
  /* width: 30em; */
  height: auto;
  margin: 1em 2em;
  margin-bottom: 5em;
}
.jobtitle{
  margin-top: 1em !important;
}
  .list-group{
    text-align: center;
    text-decoration: none;
    /* overflow:scroll; */
  }
  
  el-button{
    font-size: 1em !important;
    color:black !important;
    font-weight: 350;
    padding-left: 0.2em;
    padding-right: 0.2em;
  }
}
.button {
  display: block;
  position: relative;
  float: left;
  width: 120px;
  padding: 0;
  margin: 10px 20px 10px 0;
  font-weight: 600;
  text-align: center;
  line-height: 50px;
  /* color: #FFF; */
  border-radius: 5px;
  transition: all 0.2s ;
}

.btnFloat {
  background: none;
  box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.5);
}

.btnFloat:before {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 120px;
  height: 50px;
  border-radius: 5px;
  transition: all 0.2s ;
}


.btnOrange.btnFloat:before {
  background: #FFAA40;
}


</style>
